import { Link } from "react-location";
import ScreenWrapper from "../../../components/common/ScreenWrapper";
import SuccessIcon from "../../../assets/success.icon";

const OrderSuccess = () => {
  return (
    <ScreenWrapper title="Order Placed">
      <main className="relative lg:min-h-full font-nunito">
        <div className="h-80 overflow-hidden lg:absolute lg:h-full lg:w-1/2 lg:pr-4 xl:pr-12 flex items-center justify-center">
          <SuccessIcon
            width="80%"
            height="80%"
            className="object-contain max-h-full text-primary-500"
          />
        </div>

        <div>
          <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:grid lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8 lg:py-32 xl:gap-x-24">
            <div className="lg:col-start-2">
              <h1 className="text-sm font-medium text-primary-600">
                Order successful
              </h1>
              <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                Thanks for ordering
              </p>
              <p className="mt-2 text-base text-gray-500">
                We appreciate your order, we&rsquo;re currently processing it.
                So hang tight and we&rsquo;ll send you confirmation very soon!
              </p>

              {/* <dl className="mt-16 text-sm font-medium">
                <dt className="text-gray-900">Tracking number</dt>
                <dd className="mt-2 text-indigo-600">&mdash;</dd>
              </dl> */}

              {/* <dl className="space-y-6 border-t border-gray-200 pt-6 mt-6 text-sm font-medium text-gray-500">
                <div className="flex items-center justify-between border-t border-gray-200 pt-6 text-gray-900">
                  <dt className="text-base">Total</dt>
                  <dd className="text-base">&mdash;</dd>
                </div>
              </dl> */}

              <dl className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4 text-sm text-gray-600">
                <div>
                  <dt className="font-medium text-gray-900">
                    {/* Shipping Address */}
                  </dt>
                  <dd className="mt-2">
                    <address className="not-italic">
                      <span className="block text-gray-500">
                        Your order will be processed and dispatched shortly.
                      </span>
                      {/* <span className="block text-gray-500 mt-1">
                        You can track your order from the orders page.
                      </span> */}
                    </address>
                  </dd>
                </div>
                {/* <div>
                  <dt className="font-medium text-gray-900">
                    Payment Information
                  </dt>
                  <dd className="mt-2 space-y-2 sm:flex sm:space-x-4 sm:space-y-0">
                    <div className="flex-none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-4 h-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
                        />
                      </svg>
                    </div>
                    <div className="flex-auto">
                      <p className="text-gray-900">Payment confirmed</p>
                    </div>
                  </dd>
                </div> */}
              </dl>

              <div className="mt-16 border-t border-gray-200 py-6 text-right flex justify-between gap-4">
                <Link
                  to="/products"
                  className="text-sm font-medium text-primary-600 hover:text-primary-700"
                >
                  Continue Shopping
                  {/* <span aria-hidden="true"> &rarr;</span> */}
                </Link>
                <Link
                  to="/orders"
                  className="text-sm font-medium text-primary-600 hover:text-primary-700"
                >
                  View Orders
                  {/* <span aria-hidden="true"> &rarr;</span> */}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </ScreenWrapper>
  );
};

export default OrderSuccess;
